<template>
  <div
    class="inline-flex h-5.5 items-end gap-x-1 pl-1"
    data-test="chat-event-bubble-meta"
  >
    <p
      v-if="isEdited"
      class="mb-0 text-label-r-12-18 leading-3 text-fg-base-fg22"
      :title="editedTitle"
    >
      {{ $t('chat.edited') }}
    </p>
    <wui-icon
      v-if="isPinned"
      name="pinM"
      class="h-4! w-4! shrink-0 text-fg-base-fg22"
      :title="$t('chat.messageIsPinned')"
    />
    <p
      class="mb-0 text-label-r-12-18 leading-3 text-fg-base-fg22"
      :data-test="timeTestId"
    >
      {{ time }}
    </p>
    <message-status
      v-if="showStatus && event"
      :is-group="isGroup"
      :event="event"
      :contact-id="contactId"
      :show-error="showError"
    />
  </div>
</template>

<script lang="ts" setup>
import { WuiIcon } from '@wui/common-library'
import { HistoryMessageItem, MessageIncomingEvent, MessageOutgoingEvent } from '@wui/im'

import { MessageStatus } from '../../status'

withDefaults(defineProps<{
  time: string
  timeTestId?: string
  isEdited?: boolean
  editedTitle?: string | undefined
  isPinned?: boolean
  showStatus?: boolean
  event?: HistoryMessageItem<MessageOutgoingEvent | MessageIncomingEvent> | undefined
  isGroup?: boolean
  contactId?: string
  showError?: boolean
}>(), {
  timeTestId: 'message-time',
  isEdited: false,
  editedTitle: undefined,
  isPinned: false,
  showStatus: false,
  event: undefined,
  isGroup: false,
  contactId: '',
  showError: false,
})
</script>
